import { BackgroundColor, snakeCase } from "@silversea-ssc/ui-components-react";
import LinkCard from "components/Card/LinkCard";
import React from "react";
import { AsCardFragment } from "types/graphql-types";

const ShipFacilityCard: React.FC<
  React.PropsWithChildren<{
    card: AsCardFragment;
    openModal: () => void;
    backgroundColor?: BackgroundColor;
  }>
> = ({ card, openModal, backgroundColor = "white" }) => {
  const trackingName = card?.trackingName?.en
    ? snakeCase(card?.trackingName?.en)
    : undefined;
  return (
    <LinkCard
      backgroundColor={backgroundColor}
      trackingName={trackingName}
      image={card.image}
      imageRatio="card-panorama"
      imageAltText={card?.title?.localized}
      title={card?.title?.localized}
      description={<p>{card?.description?.localized}</p>}
      action={{ onClick: openModal }}
    />
  );
};

export default ShipFacilityCard;
